import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const CommonTranslations = wrapTranslationsSchema({
	name: 'CommonTranslations',
	title: 'Common Translations',
	sanityId: 'common',
	fields: {
		yes: 'yes',
		yesRemove: 'yes, remove',
		no: 'no',
		in: 'in',
		and: 'and',
		edit: 'Edit',
		save: 'Save',
		delete: 'Delete',
		submit: 'Submit',
		continue: 'Continue',
		cancel: 'Cancel',
		close: 'Close',
		open: 'Open',
		sku: 'SKU',
		choose: 'Choose',
		moreDetails: 'More details',
		back: 'Back',
		next: 'Next',
		finish: 'Finish',
		viewAll: 'View all',
		viewMore: 'View more',
		notAvailable: 'Not available',
		multiple: 'Multiple',
		learnMore: 'Learn more',
		reset: 'Reset',
		all: 'All',
		apply: 'Apply',
		ok: 'OK',
		okay: 'Okay',
		optional: 'Optional',
		clearAll: 'Clear All',
		entityTypeSupplier: 'Supplier',
		entityTypeProductGood: 'Goods',
		entityTypeProductDigitalService: 'Digital',
		entityTypeProductConsultingService: 'Service',
		entityTypeProductCatalog: 'Catalog',
		entityTypeMarketplaceConceptLayout: 'Concept',
		entityTypeMarketplaceCollectionLayout: 'Collection',
		entityTypeMarketplaceBundleLayout: 'Bundle',
		entityTypeMarketplaceProcessLayout: 'Process',
		entityTypeMarketplaceCategoryLayout: 'Category',
		entityTypeMarketplaceSubcategoryLayout: 'Subcategory',
		copyLinkToClipboard: 'Copy link to heading',
		copiedLinkToClipboard: 'Copied!',
		reactionLike: 'Like',
		reactionUnlike: 'Unlike',
		details: 'Details',
		openAIChatAssistant: 'Open {agentName} AI Chat Assistant',
		openInNewWindow: 'Open {agentName} in New Window',
		goToSubStore: 'Go to sub-store',
		na: 'N/A',
		other: 'Other',
		today: 'Today',
		yesterday: 'Yesterday',
		daysAgo: `{numberOf} days ago`,
		weeksAgo: `{numberOf} weeks ago`,
		monthsAgo: `{numberOf} months ago`,
		aWhileAgo: 'A while ago',
	},
});
